module.exports = __webpack_public_path__ + "img/zoom-in_btn.708ce1e7.svg";